import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockDurationField } from '../../../ConfigFields/Duration';
import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const ConditionsVariant = {
  schema: PatientDataStore.ConditionConfigSchema,
  Config: () => {
    const { setValue: setEncounters } = useSelectedNodeField('config.encounters');
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Condition Filters
        </Text>
        <ParentBlockSelectField
          fieldName="config.encounters.sourceBlockName"
          label="Encounters Source"
          helperText={getSourceBlockNameHelperText('encounters')}
          clearable
          onClear={() => setEncounters(undefined)}
        />
        <BlockSelectField
          fieldName="config.conditionFilters.clinicalStatus"
          label="Condition Clinical Status"
          options={PatientDataStore.CONDITION_CLINICAL_STATUS_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <BlockSelectField
          fieldName="config.conditionFilters.verificationStatus"
          label="Condition Verification Status"
          options={PatientDataStore.CONDITION_VERIFICATION_STATUS_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <BlockSelectField
          fieldName="config.conditionFilters.kind"
          label="Condition Kind"
          options={PatientDataStore.CONDITION_KIND_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <BlockDurationField
          fieldName="config.conditionFilters.encounterLookbackDuration"
          toggleLabel="Filter By Onset Encounter date"
          valueLabel="Only fetch conditions whose encounters are within last"
          unitFieldNameSuffix="units"
          required={false}
          allowedUnits={[...PatientDataStore.DURATION_UNIT_OPTIONS]}
        />

        <Divider sx={{ marginY: 2 }} />

        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
